import { ActivityServiceInterface, APIClientInterface, ListResponse, ActivityType, Activity, CauserType } from '../types'

export default class ActivityService implements ActivityServiceInterface {
	constructor(private client: APIClientInterface) {}

	public async search(sort: string, type?: ActivityType, pageNumber?: number, userId?: string, causerType?: CauserType): Promise<ListResponse<Activity>> {
		const searchParameters = new URLSearchParams({ sort })

		if (type) {
			searchParameters.set('type', type)
		}

		if (userId) {
			searchParameters.set('user_id', userId)
		}

		if (pageNumber) {
			searchParameters.set('page', pageNumber.toString())
		}

		if (causerType) {
			searchParameters.set('causer_type', causerType)
		}

		return this.client.get(`/activity?${searchParameters.toString()}`)
	}
}
